import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

/**
 * Los headers se arman en cada llamada: calculados una vez al importar,
 * quedaban congelados con el token y el operador de la primera carga
 * (un re-login sin recargar la página mandaba los viejos).
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });

export const fetchRequests = async ({ limit = 10, offset = 1, query = {}, sort } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/air-requests/filter`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const getRequest = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/air-requests/${id}`, {
    headers: withTenant(),
  });
  return res.json();
};

export const createRequest = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/air-requests`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateRequest = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/air-requests/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteRequest = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/air-requests/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

/**
 * Cambia el estado de la solicitud (Borrador / Enviada / Aprobada / Rechazada).
 * Backend: POST /air-requests/:id/estado  body: { estado: 'Aprobada' }
 */
export const setEstado = async (id, estado) => {
  const res = await apiFetch(`${API_BASE_URL}/air-requests/${id}/estado`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ estado }),
  });
  return res.json();
};
